import React from 'react';
import styles from './Billboard.module.css';

const Billboard = () => {
  return (
    <div className={styles.billboard}>
      <div className={styles.content}>
        <h3>Connecting Ideas,</h3>
        <h3>Empowering Innovation</h3>
      </div>
    </div>
  );
};

export default Billboard;